<style lang="stylus">
.preorder
    .addressee-info
    font-size 15px
    ::placeholder
        font-size 15px
    .address
        position relative
        padding 17px
        padding-left 0px
        padding-right 28px
        min-height 75px
        line-height 21px
        display flex
        margin-left: 6px;
        .address-icon
            &::before
                display: block;
                transform: translateY(11px);
        .addressee
            font-size 15px
            span
                color rgb(121, 125, 130)
        .address-detail
            font-size 13px
            color rgb(121, 125, 130)
            text-overflow ellipsis
            white-space nowrap
            overflow hidden
            max-height 50px
            width: 75vw
        .address-error-message
            font-size 11px
            color rgb(255,95,22)
        .address-no-select
            align-self center
            font-size 15px
    .bg-item
        height 75px
        display flex
        padding 17px 0
        .phone,.oil-card
            display flex
            flex-direction: column
            justify-content: center;
        .oid-card-icon
            &::before
                display block
                margin 0 4px 0 11px
        .phone-icon
            &::before
                display block
                margin 0 4px 0 11px
        .main-info
            font-size 18px
            color rgb(25, 26, 27)
        .phone-tip
            font-size 11px
            color rgb(189, 192, 197)
        label
            font-size 11px
            color rgb(189, 192, 197)


</style>
<template>

    <div class="group addressee-info" v-if="infoNeeded.address || infoNeeded.oilCard || infoNeeded.phone">
        <div class="item address" v-if="infoNeeded.address" @click="toSelectAddress">
            <icon class="address-icon" size="40" color="rgb(189, 193, 197)">dingdan-dizhidingwei</icon>
            <div v-if="hasSelectedAddress">
                <div class="addressee">{{addressSelected.name | ellipsis}} <span>{{ " " + addressSelected.phone}}</span></div>
                <div class="address-detail">{{addressSelected | addressDetail}}</div>
                <div class="address-error-message" v-show="addressErrorMsg">{{addressErrorMsg}}</div>
            </div>
            <div v-else class="address-no-select">未填写邮寄信息</div>
            <icon class="arrow">quanju_liebiaojiantou</icon>
        </div>

        <div class="bg-item" v-if="infoNeeded.oilCard">
            <icon size="27" class="oid-card-icon" color="rgb(189, 192, 197)" >jiayouqia</icon>
            <div class="oil-card">
                <div class="main-info">{{oilCardId}}</div>
                <label for="">充值加油卡帐号</label>
            </div>
        </div>

        <div v-if="infoNeeded.phone" class="bg-item info-input" >
            <icon2 size="25" class="phone-icon" color="rgb(189, 192, 197)" >dianjitongxunlu</icon2>
            <div class="phone" v-if="productsType==PRODUCT_TYPE_OIL_CARD || productsType ==PRODUCT_TYPE_EXCHANGE_CODE ">
                <input type="tel"
                maxlength="11"
                placeholder="请输入手机号"
                v-model="phone"
                @focus="focusInput"
                @blur="blurInput"
                class="main-info"
                >
                <label for="">订单信息将发送到该手机</label>
            </div>
            <div class="phone" v-if="productsType===PRODUCT_TYPE_FILM_TICKET || productsType===PRODUCT_TYPE_NET_COST || productsType===PRODUCT_TYPE_PHONE_COST">
                <div class="main-info">{{`${phone.slice(0, 3)} ${phone.slice(3, 7)} ${phone.slice(7)}`}}</div>
                <div class="phone-tip">订单信息将发送到该手机</div>
            </div>
        </div>
    </div>
</template>
<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import icon from '../../../components/icon'
  import myInput from '../../../components/input.vue'
  import _ from 'underscore'
  import CONSTANT from '../../../constant/preorder'
  import COOKIE_CONSTANT from '../../../constant/cookie'
  import {
    Toast,
    MessageBox
  } from 'mint-ui'
  import cookie from '../../../lib/cookie.js'
  import STATUS_CODE from '../../../constant/status_code'

  export default {
    props: ['productsType'],
    data() {
      return {
        addressErrorMsg: '',
        PRODUCT_TYPE_ELECTRONIC_TICKET: CONSTANT.PREORDER_PRODUCT_TYPE_ELECTRONIC_TICKET, //电子票
        PRODUCT_TYPE_FILM_TICKET: CONSTANT.PREORDER_PRODUCT_TYPE_FILM_TICKET, //订座票
        PRODUCT_TYPE_OIL_CARD: CONSTANT.PREORDER_PRODUCT_TYPE_OIL_CARD, //加油卡充值
        PRODUCT_TYPE_PHONE_COST: CONSTANT.PREORDER_PRODUCT_TYPE_PHONE_COST, //话费，
        PRODUCT_TYPE_NET_COST: CONSTANT.PREORDER_PRODUCT_TYPE_NET_COST, //流量
        PRODUCT_TYPE_EXCHANGE_CODE: CONSTANT.PREORDER_PRODUCT_TYPE_EXCHANGE_CODE, //兑换码
        PRODUCT_TYPE_NORMAL: CONSTANT.PREORDER_PRODUCT_TYPE_NORMAL, //普通商品
      }
    },
    mounted() {
      if(this.addressSelected){
        this.setLogisticsMsg()
      }
    },
    computed: {
      ...mapState({
        infoNeeded: state => state.preorder.infoNeeded,
        addressSelected: state => state.address.selectedAddress, //选中的地址
        skuList: state => state.preorder.preorderSkuList,
        orderKey: state => state.preorder.orderKey,
        orderType: state => state.preorder.orderType,
        preorderId: state => state.preorder.preorderId,
      }),
      hasSelectedAddress() {
        if (_.isEmpty(this.addressSelected)) {
          return false
        }
        return true
      },
      phone: {
        get() {
          return this.$store.state.preorder.userInput.phone && this.$store.state.preorder.userInput.phone.split(" ").join('')
        },
        set(value) {
          this.$store.commit('setInputPhone', value)
        }
      },
      oilCardId: {
        get() {
          return this.$store.state.preorder.userInput.oilCardId
        },
        set(value) {
          this.$store.commit('setInputOilCardId', value)
        }
      },
    },
    watch: {
      productsType() {
        let infoNeeded = { //需要用户填写的信息
          address: false,
          phone: false,
          personalId: false, //
          oilCard: false,
        }
        if (this.productsType === this.PRODUCT_TYPE_FILM_TICKET ||
          this.productsType === this.PRODUCT_TYPE_NET_COST ||
          this.productsType === this.PRODUCT_TYPE_PHONE_COST) {
          infoNeeded.phone = true

        } else if (this.productsType === this.PRODUCT_TYPE_EXCHANGE_CODE) {
          let userPhone = cookie(COOKIE_CONSTANT.COOKIE_USER_MOBILE)
          this.$store.commit("setInputPhone", userPhone)
          infoNeeded.phone = true

        } else if (this.productsType == this.PRODUCT_TYPE_OIL_CARD) {
          this.getUserInfo().then((data) => {
            this.$store.commit('setInputPhone', data.mobile + '')
            infoNeeded.phone = true
            infoNeeded.oilCard = true
            this.$store.commit('setInfoNeeded', infoNeeded)
          })
          return

        } else if (this.productsType === this.PRODUCT_TYPE_NORMAL) {
          if (this.orderType !== CONSTANT.PREORDER_ORDER_TYPE_CARDDELAY) {
            infoNeeded.address = true
            var self = this
            this.getAddressList().then(() => {
              self.setLogisticsMsg()
            })
          }
        }
        this.$store.commit('setInfoNeeded', infoNeeded)
      },
    },

    methods: {
      ...mapActions([
        'getAddressList',
        'getUserInfo',
        'checkLogistics'
      ]),
      checkInput() {
        if (this.infoNeeded.phone && this.phone == "") {
          Toast({
            message: '请输入手机号',
            position: 'bottom',
            duration: 3000
          })
          return false
        }
        if (this.infoNeeded.phone && this.phone.length < 11) {
          Toast({
            message: '请输入正确的手机号',
            position: 'bottom',
            duration: 3000
          })
          return false
        }
        if (this.infoNeeded.address && _.isEmpty(this.addressSelected)) {
          Toast({
            message: '请选择地址',
            position: 'bottom',
            duration: 3000
          })
          return false
        }


        return true
      },
      toSelectAddress() {
        this.$router.push({
          name: 'userAddressSelect'
        })
      },
      focusInput() {
        this.$emit('input-focus')
      },
      blurInput() {
        this.$emit('input-blur')
      },
      setErrorMsg(msg) {
        this.addressErrorMsg = msg
      },
      async setLogisticsMsg() {
        let self = this
        let data = {
          preOrderId: this.preorderId
        }
        if (this.addressSelected) {
          data.addressId = this.addressSelected.addressId
        }
        if (!data.addressId) {
          return
        }

        try {
          await this.checkLogistics(data)
        } catch (err) {
          if (err.status == STATUS_CODE.PREORDER_CHECK_LOGISTICS_ERROR_NO_SUPPORT) {
            self.addressErrorMsg = "所选商品超出配送范围，请核对您的地址"
          } else if (err.status == STATUS_CODE.PREORDER_CHECK_LOGISTICS_ERROR_LACK_ID) {
            self.addressErrorMsg = "请填写真实姓名和身份证用于进口商品清关"
          } else {
            this.$store.commit('rootApperError', err.msg)
          }
        }
      },
    },
    components: {
      icon,
      icon2: icon,
      myInput,

    },
  }

</script>
